import { TContractedUserResult } from "../types";

const redirectContractedUser = ({ redirectUrl }: TContractedUserResult): void => {
  window.location.href = redirectUrl;
};
export default redirectContractedUser;
